import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Banks\BankerAccountController::index
* @see app/Http/Controllers/Banks/BankerAccountController.php:24
* @route '//bank.finesthub.de/user-management'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '//bank.finesthub.de/user-management',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Banks\BankerAccountController::index
* @see app/Http/Controllers/Banks/BankerAccountController.php:24
* @route '//bank.finesthub.de/user-management'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Banks\BankerAccountController::index
* @see app/Http/Controllers/Banks/BankerAccountController.php:24
* @route '//bank.finesthub.de/user-management'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Banks\BankerAccountController::index
* @see app/Http/Controllers/Banks/BankerAccountController.php:24
* @route '//bank.finesthub.de/user-management'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Banks\BankerAccountController::store
* @see app/Http/Controllers/Banks/BankerAccountController.php:102
* @route '//bank.finesthub.de/user-management'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '//bank.finesthub.de/user-management',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Banks\BankerAccountController::store
* @see app/Http/Controllers/Banks/BankerAccountController.php:102
* @route '//bank.finesthub.de/user-management'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Banks\BankerAccountController::store
* @see app/Http/Controllers/Banks/BankerAccountController.php:102
* @route '//bank.finesthub.de/user-management'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Banks\BankerAccountController::update
* @see app/Http/Controllers/Banks/BankerAccountController.php:45
* @route '//bank.finesthub.de/user-management/{bankerAccount}'
*/
export const update = (args: { bankerAccount: string | number | { id: string | number } } | [bankerAccount: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '//bank.finesthub.de/user-management/{bankerAccount}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Banks\BankerAccountController::update
* @see app/Http/Controllers/Banks/BankerAccountController.php:45
* @route '//bank.finesthub.de/user-management/{bankerAccount}'
*/
update.url = (args: { bankerAccount: string | number | { id: string | number } } | [bankerAccount: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { bankerAccount: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { bankerAccount: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            bankerAccount: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        bankerAccount: typeof args.bankerAccount === 'object'
        ? args.bankerAccount.id
        : args.bankerAccount,
    }

    return update.definition.url
            .replace('{bankerAccount}', parsedArgs.bankerAccount.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Banks\BankerAccountController::update
* @see app/Http/Controllers/Banks/BankerAccountController.php:45
* @route '//bank.finesthub.de/user-management/{bankerAccount}'
*/
update.put = (args: { bankerAccount: string | number | { id: string | number } } | [bankerAccount: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Banks\BankerAccountController::destroy
* @see app/Http/Controllers/Banks/BankerAccountController.php:153
* @route '//bank.finesthub.de/user-management/{bankerAccount}'
*/
export const destroy = (args: { bankerAccount: string | number | { id: string | number } } | [bankerAccount: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '//bank.finesthub.de/user-management/{bankerAccount}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Banks\BankerAccountController::destroy
* @see app/Http/Controllers/Banks/BankerAccountController.php:153
* @route '//bank.finesthub.de/user-management/{bankerAccount}'
*/
destroy.url = (args: { bankerAccount: string | number | { id: string | number } } | [bankerAccount: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { bankerAccount: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { bankerAccount: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            bankerAccount: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        bankerAccount: typeof args.bankerAccount === 'object'
        ? args.bankerAccount.id
        : args.bankerAccount,
    }

    return destroy.definition.url
            .replace('{bankerAccount}', parsedArgs.bankerAccount.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Banks\BankerAccountController::destroy
* @see app/Http/Controllers/Banks/BankerAccountController.php:153
* @route '//bank.finesthub.de/user-management/{bankerAccount}'
*/
destroy.delete = (args: { bankerAccount: string | number | { id: string | number } } | [bankerAccount: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const BankerAccountController = { index, store, update, destroy }

export default BankerAccountController